<template>
  <div class="w-full max-w-full min-w-0 overflow-x-hidden" dir="rtl">
    <div v-if="user.user_type === 'prtnr' || user.user_type == 'ma'">
      <PartnerDashboardHero
          ref="hero"
          class="w-full max-w-full min-w-0"
          :partner-id="partnerId"
          :user="user"
      />

      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 w-full max-w-full min-w-0 overflow-x-hidden">
        <div class="lg:col-span-2 min-w-0 w-full max-w-full overflow-hidden">
          <TransactionChartSection
              ref="chart"
              class="w-full max-w-full min-w-0"
              :partner-id="partnerId"
          />

          <PartnerPaymentsList
              ref="payments"
              :partner-id="partnerId"
          />

          <TransactionItemsList
              ref="items"
              class="w-full max-w-full min-w-0"
              title="لیست فروش"
              subtitle="جزئیات آیتم‌های فروش، مرجوعی و فروش خالص"
              :partner-id="partnerId"
          />
        </div>

        <div class="min-w-0 w-full max-w-full overflow-hidden">

          <SettlementSection
              ref="settlement"
              class="w-full max-w-full min-w-0"
              :partner-id="partnerId"
          />

          <StockExitSection
              ref="stockExit"
              class="w-full max-w-full min-w-0 mt-3"
              :partner-id="partnerId"
              :user="user"
              @stock-exit-updated="refreshPartnerDashboard"
          />
        </div>
      </div>


    </div>

    <div
        v-else
        class="w-full rounded-2xl border border-red-500/30 bg-red-950/40 px-4 py-5 text-right"
    >
      <h3 class="text-sm font-bold text-red-100">
        دسترسی غیرمجاز
      </h3>
      <p class="mt-2 text-xs text-red-200">
        دسترسی برای شما مجاز نیست.
      </p>
    </div>
  </div>
</template>

<script>
import SettlementSection from './SettlementSection.vue'
import TransactionChartSection from './TransactionChartSection.vue'
import TransactionItemsList from "@/modules/partner/TransactionItemsList";
import PartnerDashboardHero from "@/modules/partner/PartnerDashboardHero";
import StockExitSection from "@/modules/partner/StockExitSection";
import PartnerPaymentsList from './PartnerPaymentsList.vue'

export default {
  name: 'PartnerNewDashboard',

  components: {
    PartnerDashboardHero,
    TransactionItemsList,
    SettlementSection,
    TransactionChartSection,
    PartnerPaymentsList,
    StockExitSection
  },

  props: {
    partnerId: {
      type: [String, Number],
      default: null
    }
  },

  methods: {
    refreshPartnerDashboard() {
      if (this.$refs.hero && typeof this.$refs.hero.fetchBalance === 'function') {
        this.$refs.hero.fetchBalance()
      }

      if (this.$refs.chart && typeof this.$refs.chart.fetchData === 'function') {
        this.$refs.chart.fetchData()
      }

      if (this.$refs.items && typeof this.$refs.items.fetchData === 'function') {
        this.$refs.items.fetchData()
      }

      if (this.$refs.payments && typeof this.$refs.payments.fetchData === 'function') {
        this.$refs.payments.fetchData()
      }

      if (this.$refs.settlement && typeof this.$refs.settlement.fetchData === 'function') {
        this.$refs.settlement.fetchData()
      }
    }
  }
}
</script>

<style scoped>
.min-w-0 {
  min-width: 0 !important;
}
</style>